/**
 * Pages are lazy chunks (App.tsx). A deploy replaces client/dist, so a tab that
 * loaded the previous index.html asks for chunk names that no longer exist and
 * the import fails. Vite reports that as `vite:preloadError`; reload once to pick
 * up the new index.html. The timestamp guard stops a reload loop if the chunk is
 * genuinely unavailable (the error then surfaces as usual).
 */

const STORAGE_KEY = 'compass:stale-chunk-reload-at';
export const STALE_CHUNK_RELOAD_GUARD_MS = 10_000;

export function installStaleChunkReload(win: Window = window, now: () => number = Date.now): void {
  win.addEventListener('vite:preloadError', (event) => {
    let last = 0;
    try {
      last = Number(win.sessionStorage.getItem(STORAGE_KEY) ?? 0);
    } catch {
      return;
    }
    if (now() - last < STALE_CHUNK_RELOAD_GUARD_MS) return;
    try {
      win.sessionStorage.setItem(STORAGE_KEY, String(now()));
    } catch {
      return;
    }
    event.preventDefault();
    win.location.reload();
  });
}
